import { MISSIONS, useAmbassadorSnapshot, bumpMission, type MissionId } from "@/lib/ambassadors/ambassadorEngine";

const LABEL: Record<MissionId, string> = {
  invite_5: "Invita 5 fans",
  nation_hype_dom: "Domina el hype nacional",
  win_nation_war: "Gana 3 nation wars",
  share_3_clips: "Comparte 3 clips",
  referrals_10: "Consigue 10 referrals",
  lead_predictions: "Lidera 25 predicciones",
};

export function AmbassadorMissions() {
  const { missions } = useAmbassadorSnapshot();
  return (
    <section className="rounded-2xl border border-border/60 bg-background/60 p-3">
      <h3 className="text-sm font-black uppercase tracking-wider">🎯 Ambassador Missions</h3>
      <ul className="mt-2 grid gap-2 sm:grid-cols-2">
        {MISSIONS.map((def) => {
          const p = missions.find((m) => m.id === def.id)!;
          const pct = Math.round((p.progress / def.goal) * 100);
          return (
            <li
              key={def.id}
              className="rounded-xl border border-border/40 bg-background/50 p-2"
              style={p.completed ? { boxShadow: `inset 0 0 0 1px ${def.reward.glow}66` } : undefined}
            >
              <div className="flex items-center justify-between gap-2">
                <div className="text-xs font-black">{LABEL[def.id]}</div>
                <div className="text-base" aria-hidden>{def.reward.badge}</div>
              </div>
              <div className="mt-1 h-1.5 overflow-hidden rounded-full bg-muted">
                <div
                  className="h-full rounded-full transition-all"
                  style={{ width: `${pct}%`, background: def.reward.glow }}
                />
              </div>
              <div className="mt-1 flex items-center justify-between text-[10px] text-muted-foreground">
                <span>{p.progress}/{def.goal}</span>
                <button
                  type="button"
                  onClick={() => bumpMission(def.id)}
                  className="rounded-full border border-border/60 px-2 py-0.5 font-bold uppercase tracking-wider hover:bg-muted/50"
                  disabled={p.completed}
                >
                  {p.completed ? def.reward.title : "+1"}
                </button>
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
